<template>
  <v-container>
    <v-row class="justify-center">
      <v-col md="6" sm="12">
        <v-card class="pa-6">
          <validation-observer ref="observer" v-slot="{ invalid }">
            <form @submit.prevent="submit">
              <validation-provider
                v-slot="{ errors }"
                name="Фамилия Имя"
                rules="required"
              >
                <v-text-field
                  v-model="name"
                  :error-messages="errors"
                  label="Фамилия Имя"
                  required
                ></v-text-field>
              </validation-provider>
              <validation-provider
                v-slot="{ errors }"
                name="Телефон"
                :rules="{
                  required: true,
                }"
              >
                <v-text-field
                  v-model="phoneNumber"
                  :error-messages="errors"
                  label="Телефон"
                  required
                ></v-text-field>
              </validation-provider>
              <validation-provider
                v-slot="{ errors }"
                name="Возратс, лет"
                rules="required"
              >
                <v-text-field
                  v-model="age"
                  :error-messages="errors"
                  label="Возраст, лет"
                  required
                ></v-text-field>
              </validation-provider>
              <validation-provider
                v-slot="{ errors }"
                name="select"
                rules="required"
              >
                <v-select
                  v-model="select"
                  :items="items"
                  :error-messages="errors"
                  label="Выбор курса"
                  data-vv-name="select"
                  required
                ></v-select>
              </validation-provider>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="checkbox"
              >
                <v-checkbox
                  v-model="checkbox"
                  :error-messages="errors"
                  value="1"
                  label="Я даю согласие на обработку персональных данных"
                  type="checkbox"
                  required
                ></v-checkbox>
              </validation-provider>

              <v-btn class="m-4 primary" type="submit" :disabled="invalid">
                записаться
              </v-btn>
              <!-- <v-btn @click="clear">  </v-btn> -->
            </form>
          </validation-observer>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";

import { required, digits, max } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("digits", {
  ...digits,
  message: "{_field_} needs to be {length} digits. ({_value_})",
});

extend("required", {
  ...required,
  message: "Поле не может быть пустым",
});

extend("max", {
  ...max,
  message: "{_field_} не больше {length} цифр",
});

export default {
  name: "SignUp",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
    snackbar: false,
    timeout: 5000,
    text: `Отлично!!! Мы вам позвоним, для уточнения деталей`,
    name: "",
    phoneNumber: "",
    age: "",
    select: null,
    items: [
      "Цифровая живопись",
      "Scratch",
      "Основы Java",
      "Web разработка",
     
    ],
    checkbox: null,
  }),

  methods: {
    async submit() {
      var date = await new Date().toLocaleString("ru", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      this.$refs.observer
        .validate()
        .then(
          axios.post("https://grif-qbit.duckdns.org/api/summer", {
            course: this.select,
            name: this.name,
            age: this.age,
            phone: this.phoneNumber,
          }).then(()=>console.log("запись отправлена"))
        )
        .then(this.clear())
        .then((this.snackbar = true));
    },
    clear() {
      this.name = "";
      this.phoneNumber = "";
      this.age = "";
      this.select = null;
      this.checkbox = null;
      this.$refs.observer.reset();
    },
  },
};
</script>

<style>
</style>